import { useAppConfigContext } from '@ltvco/refresh-lib/ctx';
import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { scrollToElement } from '@ltvco/refresh-lib/utils';
import { Reviews } from '@mui/icons-material';

import {
  COMMUNITY_BUZZ_CTA_DESCRIPTION,
  COMMUNITY_BUZZ_GA4_EVENTS,
} from 'components/CommunityBuzz/constants';

import {
  ModalContent,
  PrimaryPillButton,
  StyledIntroModal,
} from './components';

interface CommunityBuzzIntroModalProps {
  open: boolean;
  onClose: () => void;
  make: string;
  model: string;
  year: string;
  trim: string;
}

export const CommunityBuzzIntroModal = ({
  open,
  onClose,
  make,
  model,
  year,
  trim,
}: CommunityBuzzIntroModalProps) => {
  const { trackEventGA4 } = useAppConfigContext();
  const vehicleName = [year, make, model, trim].filter(Boolean).join(' ');

  const handlePrimaryActionClick = () => {
    onClose();
    scrollToElement('community-buzz-section');
    trackEventGA4({
      event_name: COMMUNITY_BUZZ_GA4_EVENTS.name,
      type: COMMUNITY_BUZZ_GA4_EVENTS.type,
    });
  };

  return (
    <StyledIntroModal open={open} onClose={onClose} hasCloseIcon>
      <ModalContent>
        <Reviews fontSize="large" sx={{ color: 'primary.main' }} />
        <Stack spacing={1} alignItems="center">
          <Text variant="h3">{COMMUNITY_BUZZ_CTA_DESCRIPTION.title}</Text>
          <Text variant="h4">{COMMUNITY_BUZZ_CTA_DESCRIPTION.subtitle}</Text>
          <Text variant="body1" maxWidth={560}>
            {COMMUNITY_BUZZ_CTA_DESCRIPTION.descriptionWithVehicleName(
              vehicleName
            )}
          </Text>
        </Stack>
        <PrimaryPillButton
          variant="contained"
          onClick={handlePrimaryActionClick}
        >
          See the most talked about topics
        </PrimaryPillButton>
      </ModalContent>
    </StyledIntroModal>
  );
};
